import React from 'react';
import { Box } from '@mui/material';
import Problem from './Problem';
import HTMLContent from './content-blocks/HTMLContent';
export default function ProblemSet({ data, startNumber = 1 }) {
  return <>
    <Box sx={{ mb: 3, maxWidth: '65ch' }}><HTMLContent content={data.instructions} /></Box>
    {data.problems.map((problem, index) => <Problem key={problem.id} {...problem} questionKey={problem.id} number={startNumber + index} />)}
  </>;
}
